import styled from 'astroturf/react';
import Button from 'src/components/Button';

const CloneButton = styled(Button)`
  font-size: 14px;
`;

export default {
  CloneButton,
};
